import HttpService from './http.service';

// Interfaz para la estructura de un documento
export interface Document {
  category: string;
  name: string;
  size: number;
  type: string;
  content?: string; // Ahora es opcional
  url?: string;    // URL de Firebase Storage
}

// Interfaz para los datos que espera el backend
export interface CompanyRequestDto {
  email: string;
  name: string;
  lastName: string;
  profilePictureUrl: string;
  isActive: boolean;
  googleId?: string;

  category?: string;
  companyDescription?: string;
  documents?: Document[];
  employeeCount?: number;
  leads?: number;
  legalRepId?: string;
  legalRepName?: string;
  locations?: string[];
  phone?: string;
  profileImage?: string;
  serviceImages?: string[];
  services?: string[];
  state?: string;
  termsAccepted?: boolean;
  yearsExperience?: number;
}

// Interfaz para la respuesta del backend al crear una empresa
export interface CompanyResponse {
  id: string;
  name: string;
  status: string;
  // Otros campos que devuelva el backend
}

// Servicio para el onboarding
export const OnboardingService = {
  // Enviar los datos de la empresa al backend
  submitCompanyData: async (companyData: CompanyRequestDto) => {
    try {
      const response = await HttpService.post<CompanyResponse>('/api/companies', companyData);
      return response.data;
    } catch (error: any) {
      throw error;
    }
  },

  // Subir documentos
  uploadDocument: async (documentFile: File, category: string, companyId: string) => {
    try {
      // Crear un FormData para enviar el archivo
      const formData = new FormData();
      formData.append('file', documentFile);
      formData.append('category', category);
      formData.append('companyId', companyId);

      const response = await HttpService.post('/api/documents/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Subir imagen de perfil
  uploadProfileImage: async (imageFile: File, companyId: string) => {
    try {
      const formData = new FormData();
      formData.append('file', imageFile);
      formData.append('companyId', companyId);

      const response = await HttpService.post('/api/companies/profile-image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Subir imágenes de servicios
  uploadServiceImages: async (serviceImages: string[], companyId: string) => {
    try {
      // Enviar las imágenes en base64 directamente
      const response = await HttpService.post('/api/companies/service-images', {
        images: serviceImages,
        companyId: companyId
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Actualizar la URL de la imagen de perfil
  updateProfileImage: async (profileImageUrl: string, companyId: string) => {
    try {
      const response = await HttpService.put(`/api/companies/${companyId}/profile-image`, {
        profilePictureUrl: profileImageUrl
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

//export default OnboardingService;